const SpinnerLoader = ({ color = '#7F56DA' }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ width: '100%', height: '100%' }}
    >
      <div
        className="spinner-border"
        role="status"
        style={{ width: '2rem', height: '2rem', color }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default SpinnerLoader;
